import styled from 'styled-components'
import { maxQuery } from '../../../../helpers'

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #272B4A;
  cursor: pointer;
  padding: 1.5em 1em;
  border: 0.688106px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  height: fit-content;
  width: 100%;
  max-width: 220px;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
  }

  div.img--container {
    width: 5.5rem;
    height: 5.5rem;
    border-radius: 50%;
    margin-bottom: 1em;
    display: flex;
    align-items: center;
    border: 2px solid ${({ theme }) => theme.primary};
    justify-content: center;
    color: ${({ theme }) => theme.primary};
    font-size: 1.3rem;
    font-weight: 600;
  }

  h3 {
    font-weight: 500;
    font-size: 0.95rem;
    text-align: center;
    margin-bottom: 0.4em;
    color: rgba(255, 255, 255, 0.9);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 0 0.5em;
  }

  p {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    margin-bottom: 0.8em;
    ${maxQuery('sm')} {
      font-size: 0.8rem;
    }
  }

  .role-badge {
    display: inline-block;
    padding: 0.35em 0.9em;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    margin-top: 0.3em;

    &.manager {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
    }

    &.dispatcher {
      background: #f39c12;
      color: #fff;
    }

    &.staff {
      background: #3b82f6;
      color: #fff;
    }
  }
`
